import { userSettingsModel } from 'APP/model/model';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import Entities from 'STORE';

export const setDeviceStatus = async (deviceId: string, status: DeviceStatus): Promise<boolean> => {
  try {
    await userSettingsModel.setDeviceStatus({ deviceId, status });
    Entities.sessionsStore.setSessionDeviceStatus(deviceId, status);
    return true;
  } catch (error) {
    return false;
  }
};
